import { createReducer, on } from "@ngrx/store";
import { OrganizationsState } from "./organizations.state";
import { createOrganizationSuccess, deleteOrganizationSuccess, loadMyOrganization, loadMyOrganizationFailure, loadMyOrganizationSuccess, loadOrganizations, loadOrganizationsFailure, loadOrganizationsSuccess, selectOrganization, selectOrganizationFailure, selectOrganizationSuccess, updateOrganizationSuccess } from "./organizations.actions";
import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { OrganizationDto } from "./organizations.model";


export const adapter: EntityAdapter<OrganizationDto> = createEntityAdapter<OrganizationDto>();

export const initialOrganizationsState: OrganizationsState = adapter.getInitialState({
  organizationsLoaded: false,
  loadingOrganizations: false,
  errorLoadingOrganizations: null,

  memberTenantIds: [],

  myOrganization: null,
  myOrganizationLoaded: false,
  loadingMyOrganization: false,
  errorLoadingMyOrganization: null,

  selectedOrganization: null,
  selectingOrganization: false
});


export const organizationsReducer = createReducer(
  initialOrganizationsState,
  on(loadOrganizations, (state) => ({
    ...state,
    loadingOrganizations: true,
    errorLoadingOrganizations: null
  })),
  on(loadOrganizationsSuccess, (state, { organizations, memberTenantIds }) =>
    adapter.setAll(organizations, {
      ...state,
      organizationsLoaded: true,
      loadingOrganizations: false,
      errorLoadingOrganizations: null,
      memberTenantIds
    })
  ),
  on(loadOrganizationsFailure, (state, { error }) =>
    adapter.removeAll({
      ...state,
      loadingOrganizations: false,
      errorLoadingOrganizations: error,
      memberTenantIds: []
    })
  ),

  on(loadMyOrganization, (state) => ({
    ...state,
    myOrganization: null,
    loadingMyOrganization: true,
    errorLoadingMyOrganization: null
  })),
  on(loadMyOrganizationSuccess, (state, { organization }) => ({
    ...state,
    myOrganization: organization,
    myOrganizationLoaded: true,
    loadingMyOrganization: false,
    errorLoadingMyOrganization: null
  })),
  on(loadMyOrganizationFailure, (state, { error }) => ({
    ...state,
    loadingMyOrganization: false,
    errorLoadingMyOrganization: error
  })),

  on(selectOrganization, (state) => ({
    ...state,
    selectingOrganization: true
  })),
  on(selectOrganizationSuccess, (state, { organization }) => ({
    ...state,
    selectedOrganization: organization,
    selectingOrganization: false,
    // Reset organizationsLoaded so orgs are reloaded for the new tenant context
    // This is important when switching between Datex and non-Datex orgs
    organizationsLoaded: false
  })),
  on(selectOrganizationFailure, (state) => ({
    ...state,
    selectingOrganization: false
  })),

  on(createOrganizationSuccess, (state, { organization }) => {
    return adapter.addOne(organization, state);
  }),
  on(updateOrganizationSuccess, (state, { organization }) => {
    return adapter.upsertOne(organization, state);
  }),
  on(deleteOrganizationSuccess, (state, { organization }) => {
    return adapter.removeOne(organization.id, state);
  })
);